import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { ICompanyDocument } from '~/types/document/models'

export const {
  getDocumentListData: getCompanyDocumentListData,
  getDocumentDataById: getCompanyDocumentDataById,
  getDocumentListDataByParentId: getCompanyDocumentListDataByCompanyId,
} = makeDocumentMockData<ICompanyDocument>({
  entityName: 'company',
  storageKeyPrefix: 'company',
})
